import Enumerator from './Enumerator';

export const docTypes = [
  '__struct',
  '__billing_event',
  '__datum_assetfinance',
  '__datum_call',
  '__datum_campaign',
  '__datum_contact',
  '__datum_filter',
  '__datum_job',
  '__datum_list',
  '__datum_loan',
  '__datum_note',
  '__datum_report',
  '__datum_riskinsurance',
  '__datum_ticket',
  '__definition_campaign',
  '__definition_checklist',
  '__definition_commission',
  '__definition_dashboard',
  '__definition_document',
  '__definition_field',
  '__definition_jobtype',
  '__definition_label',
  '__definition_marketing',
  '__definition_message',
  '__definition_script',
  '__definition_workflow',
  '__global_account',
  '__global_bankstatements',
  '__global_clientaccess',
  '__global_documentsignature',
  '__global_organization',
  '__global_videoconferencing',
  '__operation_export',
  '__operation_import',
  '__operation_lodgement',
  '__operation_notification'
];

export class DocType extends Enumerator {
  static default() {
    return this.of('__struct');
  }
}
DocType.initEnum(docTypes);

export default {
  docTypes,
  DocType
};
